import React from "react";
import { Link } from "react-router-dom";
import AuthInput from "../../Components/AuthInput";
import useLogin from "../Login/useLogin";
import OTPInput from "../../Components/OTPInput";
import AuthScreenLayout from "../../Components/Auth/AuthScreenLayout";
import AuthBrandMark from "../../Components/Auth/AuthBrandMark";
import {
  authPrimaryButtonClass as primaryBtn,
  authSecondaryButtonClass as secondaryBtn,
} from "../../Components/Auth/authClasses";

export default function Signup() {
  const {
    signupHandleSubmit,
    signupRegister,
    onSignup,
    signupErrors,
    showOtpForm,
    otp,
    setOtp,
    onOtpSubmit,
    otpError,
    otpSuccess,
    resendLoading,
    settings,
    onResendOtp,
    onSkip,
    signupEmail,
  } = useLogin({ signupStandalone: true });

  return (
    <AuthScreenLayout cardMaxWidthClass="max-w-2xl">
      <AuthBrandMark settings={settings} />

      {showOtpForm ? (
        <form onSubmit={onOtpSubmit} className="space-y-6">
          <div className="text-center">
            <h1 className="text-xl font-semibold tracking-tight text-white sm:text-2xl">Verify OTP</h1>
            <p className="mt-2 text-sm leading-relaxed text-white/70">
              A verification code has been sent to{" "}
              <strong className="font-medium text-white">{signupEmail || "your email"}</strong>
            </p>
          </div>

          <OTPInput value={otp} onChange={setOtp} length={6} disabled={resendLoading} variant="glass" />

          {otpError ? <p className="text-center text-sm text-red-400">{otpError}</p> : null}
          {otpSuccess ? <p className="text-center text-sm text-emerald-400">{otpSuccess}</p> : null}

          <div className="space-y-3 pt-1">
            <button type="submit" className={primaryBtn} disabled={otp.length !== 6}>
              Verify OTP
            </button>
            <button type="button" className={secondaryBtn} onClick={onResendOtp} disabled={resendLoading}>
              {resendLoading ? "Resending…" : "Resend OTP"}
            </button>
            <button
              type="button"
              onClick={onSkip}
              className="w-full text-center text-sm text-white/65 transition hover:text-white"
            >
              Skip for now
            </button>
          </div>
        </form>
      ) : (
        <>
          <div className="mb-6 text-center sm:mb-8">
            <p className="text-sm text-white/65">Create your account</p>
          </div>

          <form onSubmit={signupHandleSubmit(onSignup)} className="space-y-1 sm:space-y-0">
            <AuthInput
              label="Name"
              type="text"
              name="name"
              id="name"
              placeholder="Enter your name"
              errors={signupErrors}
              register={signupRegister}
              variant="glass"
            />
            <AuthInput
              label="Email"
              type="email"
              name="email"
              id="signup-email"
              placeholder="Enter Your Email"
              errors={signupErrors}
              register={signupRegister}
              variant="glass"
            />
            <AuthInput
              label="Password"
              type="password"
              name="password"
              id="signup-password"
              placeholder="Enter Your Password"
              errors={signupErrors}
              register={signupRegister}
              variant="glass"
            />
            <AuthInput
              label="Confirm Password"
              type="password"
              name="password_confirmation"
              id="signup-password-confirmation"
              placeholder="Confirm Your Password"
              errors={signupErrors}
              register={signupRegister}
              variant="glass"
            />
            <div className="pt-4">
              <button type="submit" className={primaryBtn}>
                Sign Up
              </button>
            </div>
          </form>

          <p className="mt-8 text-center text-sm text-white/75">
            Already have an account?{" "}
            <Link
              to="/Login"
              className="font-semibold text-white transition hover:text-white/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue"
            >
              Sign in
            </Link>
          </p>
        </>
      )}
    </AuthScreenLayout>
  );
}
